<template>
	<div class="content-wrapper">
		<section class="content-header">
			<h1>
				{{ title }}<small>{{ sTitle }}</small>
			</h1>
		</section>
		<section class="content">
			<router-view @setHeader="setHeader" />
		</section>
	</div>
</template>
<script>
	export default {
		name: 'AppCntPage',
		data() {
			return {
				title: 'TITULO',
				sTitle: '',
			};
		},
		methods: {
			setHeader(pay) {
				if (pay[0] != undefined) this.title = pay[0];
				if (pay[1] != undefined) this.sTitle = pay[1];
			},
		},
	};
</script>
<style scoped>
	.content-wrapper {
		height: calc(100vh) !important;
		overflow-y: auto !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cnt-app/components/content.wrapper.vue